var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('base-alert',{staticClass:"text-center",attrs:{"type":"danger"}},_vm._l((_vm.alerts),function(alert){return _c('div',{key:alert},[_c('span',{domProps:{"innerHTML":_vm._s(alert)}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }